import React, { PropsWithChildren } from "react";

interface PropsType extends PropsWithChildren {}

export default function SideBarFooter({ children }: PropsType) {
  return (
    <div
      className="border-t-[1px] border-[#DADADA] bg-white p-7"
      style={{ filter: "drop-shadow(0px 0px 20px rgba(0,0,0,0.1))" }}
    >
      {children}
    </div>
  );
}
